import Label from './label.vue'
import ArticleLists from './articleLists.vue'
import Article from './article.vue'
import Banner from './banner.vue'
import Notice from './notice.vue'
import ArtLabel from './artLabel.vue'

export default {
	Label,
	ArticleLists,
	Article,
	Banner,
	Notice,
	ArtLabel
}



// WEBPACK FOOTER //
// ./src/views/content/index.js